import { axiosBaseQuery } from 'store/query';
import { quickBooksApiInstance } from 'api/instance';

// Production Control Center build (master + the QuickBooks module only):
// the QuickBooks base query lives with the QuickBooks API instead of in the
// shared store/query.ts, so that POS file stays byte-identical to master.
// Same construction as the QB line's store/query.ts quickBooksApiQuery.
export const quickBooksApiQuery = axiosBaseQuery({
  instance: quickBooksApiInstance,
});
